import { useIsCircleAiEnabled } from "@circle-react/components/CircleAi/useCircleAiFeatureFlags";
import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";

import { CircleAIDockRecentChatsSectionContent } from "./CircleAIDockRecentChatsSectionContent";

export const CircleAIDockRecentChatsSection = () => {
  const isAdmin = useIsCommunityAdmin();
  const isCircleAiEnabled = useIsCircleAiEnabled();

  if (!isAdmin || !isCircleAiEnabled) return null;

  return <CircleAIDockRecentChatsSectionContent />;
};
